'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var dataApprovalLevelsInit = exports.dataApprovalLevelsInit = undefined;

exports.dataApprovalLevelsInit = dataApprovalLevelsInit = function dataApprovalLevelsInit(c) {
    var t = this,
        appManager = c.appManager,
        requestManager = c.requestManager,
        apiPath = appManager.getApiPath(),
        displayPropertyUrl = appManager.getDisplayPropertyUrl();

    return {
        baseUrl: apiPath + '/dataApprovalLevels.json',
        params: ['order=level:asc', 'fields=id,displayName~rename(name),level', 'paging=false'],
        success: function success(r) {
            appManager.addDataApprovalLevels(r.dataApprovalLevels);
            requestManager.ok(this);
        }
    };
};
//# sourceMappingURL=dataApprovalLevelsInit.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/lib/init/dataApprovalLevelsInit.js
 ** module id = 127
 ** module chunks = 0 1
 **/